export default __webpack_public_path__ + "008f5b6429dcf6569807225402e15636.png";